import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function MasterMenu(){
    return (
        <section className="container mt-4">
            <div className="row nurseInpatient">
                <div className='col-md-12 col-12'>
                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >General Master Setting</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info mb-3">
                    <div className="btn-group">
                    <a href="/user-register"><button type="button" className="btn btn"><span >User Master</span></button></a></div>
                    <div className="btn-group">
                    <a href="/change-password"><button type="button" className="btn btn"><span >Change Password</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-department"><button type="button" className="btn btn"><span >Add Department</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-template"><button type="button" className="btn btn"><span >Add Template</span></button></a></div>
                    <div className="btn-group">
                    <a href="/speech"><button type="button" className="btn btn"><span >Speech</span></button></a></div>
                    <div className="btn-group">
                    <a href="/calendar"><button type="button" className="btn btn"><span >To Do List</span></button></a></div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >OP Details</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/pat-bill-search"><button type="button" className="btn btn"><span >Patient Billing Details</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-patient"><button type="button" className="btn btn"><span >New Patient- registration</span></button></a></div>
                    <div className="btn-group">
                    <a href="patient_barcode_search.php"><button type="button" className="btn btn"><span >Patient ID Print</span></button></a></div>
                    <div className="btn-group">
                    <a href="/pat-register-search"><button type="button" className="btn btn"><span >Patients Register Report</span></button></a></div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >OP Billing Masters</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/add-minor-cat"><button type="button" className="btn btn"><span >OP Billing Category</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-minor-comp"><button type="button" className="btn btn"><span >OP Billing Component</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-consultant"><button type="button" className="btn btn"><span >Add Consultant</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-subcat"><button type="button" className="btn btn"><span >Add Lab Master</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-radio"><button type="button" className="btn btn"><span >Add Radiology Master</span></button></a></div>

                    </div>
                    </div>

               </div>
            </div>
        </section>
    )
}

export default MasterMenu;